import * as Mod1 from "./discourse/admin-discourse-ai-plugin-route-map";
import * as Mod2 from "./discourse/admin-discourse-ai-route-map";
import * as Mod3 from "./discourse/admin/adapters/ai-agent";
import * as Mod4 from "./discourse/admin/adapters/ai-embedding";
import * as Mod5 from "./discourse/admin/adapters/ai-feature";
import * as Mod6 from "./discourse/admin/adapters/ai-llm";
import * as Mod7 from "./discourse/admin/adapters/ai-mcp-server";
import * as Mod8 from "./discourse/admin/adapters/ai-secret";
import * as Mod9 from "./discourse/admin/adapters/ai-tool";
import * as Mod10 from "./discourse/admin/models/ai-agent";
import * as Mod11 from "./discourse/admin/models/ai-embedding";
import * as Mod12 from "./discourse/admin/models/ai-feature";
import * as Mod13 from "./discourse/admin/models/ai-llm";
import * as Mod14 from "./discourse/admin/models/ai-mcp-server";
import * as Mod15 from "./discourse/admin/models/ai-secret";
import * as Mod16 from "./discourse/admin/models/ai-tool";
import * as Mod17 from "./discourse/components/admin-report-emotion";
import * as Mod18 from "./discourse/components/ai-agent-example";
import * as Mod19 from "./discourse/components/ai-agent-llm-selector";
import * as Mod20 from "./discourse/components/ai-agent-tool-options";
import * as Mod21 from "./discourse/components/ai-artifact";
import * as Mod22 from "./discourse/components/ai-blinking-animation";
import * as Mod23 from "./discourse/components/ai-bot-chats-tab";
import * as Mod24 from "./discourse/components/ai-bot-conversations";
import * as Mod25 from "./discourse/components/ai-bot-docked-composer";
import * as Mod26 from "./discourse/components/ai-bot-header-icon";
import * as Mod27 from "./discourse/components/ai-bot-sidebar-empty-state";
import * as Mod28 from "./discourse/components/ai-bot-sidebar-new-conversation";
import * as Mod29 from "./discourse/components/ai-composer-helper-menu";
import * as Mod30 from "./discourse/components/ai-conversation-sidebar-context-menu";
import * as Mod31 from "./discourse/components/ai-credit-bar";
import * as Mod32 from "./discourse/components/ai-feature-card";
import * as Mod33 from "./discourse/components/ai-features-list";
import * as Mod34 from "./discourse/components/ai-full-page-search";
import * as Mod35 from "./discourse/components/ai-gist-toggle";
import * as Mod36 from "./discourse/components/ai-helper-custom-prompt";
import * as Mod37 from "./discourse/components/ai-helper-loading";
import * as Mod38 from "./discourse/components/ai-helper-options-list";
import * as Mod39 from "./discourse/components/ai-indicator-wave";
import * as Mod40 from "./discourse/components/ai-llm-attachment-types";
import * as Mod41 from "./discourse/components/ai-llm-selector";
import * as Mod42 from "./discourse/components/ai-mcp-server-editor-form";
import * as Mod43 from "./discourse/components/ai-mcp-server-editor";
import * as Mod44 from "./discourse/components/ai-post-helper-menu";
import * as Mod45 from "./discourse/components/ai-quota-duration-selector";
import * as Mod46 from "./discourse/components/ai-regen-summaries-buttons";
import * as Mod47 from "./discourse/components/ai-search-discoveries-tooltip";
import * as Mod48 from "./discourse/components/ai-search-discoveries";
import * as Mod49 from "./discourse/components/ai-secret-editor-form";
import * as Mod50 from "./discourse/components/ai-secret-selector";
import * as Mod51 from "./discourse/components/ai-sentiment-horizontal-bar";
import * as Mod52 from "./discourse/components/ai-split-topic-suggester";
import * as Mod53 from "./discourse/components/ai-summary-skeleton";
import * as Mod54 from "./discourse/components/ai-tool-editor-form";
import * as Mod55 from "./discourse/components/ai-tool-editor";
import * as Mod56 from "./discourse/components/ai-tool-selector";
import * as Mod57 from "./discourse/components/ai-topic-gist";
import * as Mod58 from "./discourse/components/bulk-actions/ai-regen-summaries";
import * as Mod59 from "./discourse/components/modal/ai-agent-mcp-tool-selector-modal";
import * as Mod60 from "./discourse/components/modal/ai-agent-response-format-editor";
import * as Mod61 from "./discourse/components/modal/ai-llm-quota-modal";
import * as Mod62 from "./discourse/components/modal/ai-mcp-server-tools-modal";
import * as Mod63 from "./discourse/components/modal/ai-regen-summaries-modal";
import * as Mod64 from "./discourse/components/modal/ai-secret-create-modal";
import * as Mod65 from "./discourse/components/modal/ai-summary-modal";
import * as Mod66 from "./discourse/components/modal/ai-tool-test-modal";
import * as Mod67 from "./discourse/components/modal/chat-modal-channel-summary";
import * as Mod68 from "./discourse/components/modal/debug-ai-modal";
import * as Mod69 from "./discourse/components/modal/diff-modal";
import * as Mod70 from "./discourse/components/modal/share-full-topic-modal";
import * as Mod71 from "./discourse/components/modal/share-modal";
import * as Mod72 from "./discourse/components/modal/spam-test-modal";
import * as Mod73 from "./discourse/components/modal/thumbnail-suggestions";
import * as Mod74 from "./discourse/components/model-accuracies";
import * as Mod75 from "./discourse/components/post-menu/ai-cancel-streaming-button";
import * as Mod76 from "./discourse/components/post-menu/ai-debug-button";
import * as Mod77 from "./discourse/components/post-menu/ai-retry-streaming-button";
import * as Mod78 from "./discourse/components/post-menu/ai-share-button";
import * as Mod79 from "./discourse/components/post/ai-agent-flair";
import * as Mod80 from "./discourse/components/post/meta-data/ai-cancel-streaming";
import * as Mod81 from "./discourse/components/rag-options-fk";
import * as Mod82 from "./discourse/components/rag-upload-progress";
import * as Mod83 from "./discourse/components/rag-uploader";
import * as Mod84 from "./discourse/components/reviewable/ai-chat-message";
import * as Mod85 from "./discourse/components/reviewable/ai-post";
import * as Mod86 from "./discourse/components/reviewable/ai-tool-action";
import * as Mod87 from "./discourse/components/suggestion-menus/ai-category-suggester";
import * as Mod88 from "./discourse/components/suggestion-menus/ai-tag-suggester";
import * as Mod89 from "./discourse/components/suggestion-menus/ai-title-suggester";
import * as Mod90 from "./discourse/components/thumbnail-suggestion-item";
import * as Mod91 from "./discourse/connectors/admin-customize-theme-translation-selector/ai-theme-translate.gjs";
import * as Mod92 from "./discourse/connectors/admin-dashboard-highlights-before-kpis/ai-admin-dashboard-highlight.gjs";
import * as Mod93 from "./discourse/connectors/admin-dashboard-tabs-after/admin-sentiment-dashbboard.gjs";
import * as Mod94 from "./discourse/connectors/after-composer-title-input/ai-title-suggestion.gjs";
import * as Mod95 from "./discourse/connectors/after-d-editor/composer-open.gjs";
import * as Mod96 from "./discourse/connectors/after-filter-navigation-menu/filter-gist-toggle.gjs";
import * as Mod97 from "./discourse/connectors/after-search-result-entry/search-result-decoration.gjs";
import * as Mod98 from "./discourse/connectors/before-create-topic-button/topic-list-gist-toggle.gjs";
import * as Mod99 from "./discourse/connectors/composer-fields/agent-llm-selector.gjs";
import * as Mod100 from "./discourse/connectors/edit-topic-category__after/ai-category-suggestion.gjs";
import * as Mod101 from "./discourse/connectors/edit-topic-tags__after/ai-tag-suggestion.gjs";
import * as Mod102 from "./discourse/connectors/edit-topic-title__after/ai-title-suggestion.gjs";
import * as Mod103 from "./discourse/connectors/editor-preview/ai-image-caption-container.gjs";
import * as Mod104 from "./discourse/connectors/fast-edit-footer-after/ai-edit-suggestion-button.gjs";
import * as Mod105 from "./discourse/connectors/full-page-search-advanced-header/ai-full-page-search.gjs";
import * as Mod106 from "./discourse/connectors/full-page-search-before-results/ai-search-results-notice.gjs";
import * as Mod107 from "./discourse/connectors/full-page-search-below-search-header/ai-full-page-discobot-discoveries.gjs";
import * as Mod108 from "./discourse/connectors/post-menu-translations-dropdown/ai-post-menu-translation-extras.gjs";
import * as Mod109 from "./discourse/connectors/post-text-buttons/ai-post-helper-trigger.gjs";
import * as Mod110 from "./discourse/connectors/search-menu-before-advanced-search/ai-quick-search-loader.gjs";
import * as Mod111 from "./discourse/connectors/search-menu-results-bottom/ai-quick-search.gjs";
import * as Mod112 from "./discourse/connectors/search-menu-results-top/ai-discobot-discoveries.gjs";
import * as Mod113 from "./discourse/connectors/search-menu-results-top/ai-quick-search-info.gjs";
import * as Mod114 from "./discourse/connectors/search-menu-results-type-top/ai-quick-search-notice.gjs";
import * as Mod115 from "./discourse/connectors/split-new-topic-category-after/ai-category-suggestion.gjs";
import * as Mod116 from "./discourse/connectors/split-new-topic-tag-after/ai-tag-suggestion.gjs";
import * as Mod117 from "./discourse/connectors/split-new-topic-title-after/ai-title-suggestion.gjs";
import * as Mod118 from "./discourse/connectors/topic-map-expanded-after/ai-summary-trigger.gjs";
import * as Mod119 from "./discourse/connectors/topic-map-participants-after/ai-conversation-invite.gjs";
import * as Mod120 from "./discourse/connectors/user-messages-controls-bottom/pm-list-gist-toggle.gjs";
import * as Mod121 from "./discourse/connectors/user-preferences-interface/ai-search-discoveries.gjs";
import * as Mod122 from "./discourse/controllers/discourse-ai-bot-conversations";
import * as Mod123 from "./discourse/discourse-ai-bot-dashboard-route-map";
import * as Mod124 from "./discourse/discourse-ai-shared-conversation-show-route-map";
import * as Mod125 from "./discourse/initializers/add-ai-bot-to-community-section";
import * as Mod126 from "./discourse/initializers/admin-plugin-configuration-nav";
import * as Mod127 from "./discourse/initializers/ai-artifacts";
import * as Mod128 from "./discourse/initializers/ai-bot-pm";
import * as Mod129 from "./discourse/initializers/ai-bot-replies";
import * as Mod130 from "./discourse/initializers/ai-category-chooser-inline-suggester";
import * as Mod131 from "./discourse/initializers/ai-chat-summarization";
import * as Mod132 from "./discourse/initializers/ai-conversations-sidebar";
import * as Mod133 from "./discourse/initializers/ai-gist-connector";
import * as Mod134 from "./discourse/initializers/ai-gist-topic-list-class";
import * as Mod135 from "./discourse/initializers/ai-helper";
import * as Mod136 from "./discourse/initializers/ai-image-caption";
import * as Mod137 from "./discourse/initializers/ai-reviewable-status";
import * as Mod138 from "./discourse/initializers/ai-search-discoveries";
import * as Mod139 from "./discourse/initializers/ai-semantic-search";
import * as Mod140 from "./discourse/initializers/ai-sentiment-admin-nav";
import * as Mod141 from "./discourse/initializers/ai-tag-chooser-inline-suggester";
import * as Mod142 from "./discourse/initializers/ai-translation-topic-admin";
import * as Mod143 from "./discourse/initializers/related-topics";
import * as Mod144 from "./discourse/initializers/translation";
import * as Mod145 from "./discourse/lib/ai-bot-helper";
import * as Mod146 from "./discourse/lib/ai-errors";
import * as Mod147 from "./discourse/lib/ai-feature-setting-groups";
import * as Mod148 from "./discourse/lib/ai-helper-suggestions";
import * as Mod149 from "./discourse/lib/ai-streamer/progress-handlers";
import * as Mod150 from "./discourse/lib/ai-streamer/updaters/post-updater";
import * as Mod151 from "./discourse/lib/ai-streamer/updaters/stream-updater";
import * as Mod152 from "./discourse/lib/ai-topic-summary";
import * as Mod153 from "./discourse/lib/ai-usage-time-series";
import * as Mod154 from "./discourse/lib/copy-conversation";
import * as Mod155 from "./discourse/lib/diff-streamer";
import * as Mod156 from "./discourse/lib/llm-provider-param-helpers";
import * as Mod157 from "./discourse/lib/search-discoveries-context";
import * as Mod158 from "./discourse/lib/show-ai-helper";
import * as Mod159 from "./discourse/lib/smooth-streamer";
import * as Mod160 from "./discourse/lib/utilities";
import * as Mod161 from "./discourse/pre-initializers/ai-spam-transformers";
import * as Mod162 from "./discourse/routes/discourse-ai-bot-conversations";
import * as Mod163 from "./discourse/routes/discourse-ai-shared-conversation-show";
import * as Mod164 from "./discourse/services/ai-bot-conversations-hidden-submit";
import * as Mod165 from "./discourse/services/ai-bot-docked-submit";
import * as Mod166 from "./discourse/services/ai-bot-streaming-state";
import * as Mod167 from "./discourse/services/ai-conversations-sidebar-manager";
import * as Mod168 from "./discourse/services/ai-credits";
import * as Mod169 from "./discourse/services/discobot-discoveries";
import * as Mod170 from "./discourse/services/gists";
import * as Mod171 from "./discourse/services/image-caption-popup";
import * as Mod172 from "./discourse/services/quick-search";
import * as Mod173 from "./discourse/templates/discourse-ai-bot-conversations";
import * as Mod174 from "./lib/discourse-markdown/ai-tags";
const compatModules = {
  "discourse/admin-discourse-ai-plugin-route-map": Mod1,
  "discourse/admin-discourse-ai-route-map": Mod2,
  "discourse/admin/adapters/ai-agent": Mod3,
  "discourse/admin/adapters/ai-embedding": Mod4,
  "discourse/admin/adapters/ai-feature": Mod5,
  "discourse/admin/adapters/ai-llm": Mod6,
  "discourse/admin/adapters/ai-mcp-server": Mod7,
  "discourse/admin/adapters/ai-secret": Mod8,
  "discourse/admin/adapters/ai-tool": Mod9,
  "discourse/admin/models/ai-agent": Mod10,
  "discourse/admin/models/ai-embedding": Mod11,
  "discourse/admin/models/ai-feature": Mod12,
  "discourse/admin/models/ai-llm": Mod13,
  "discourse/admin/models/ai-mcp-server": Mod14,
  "discourse/admin/models/ai-secret": Mod15,
  "discourse/admin/models/ai-tool": Mod16,
  "discourse/components/admin-report-emotion": Mod17,
  "discourse/components/ai-agent-example": Mod18,
  "discourse/components/ai-agent-llm-selector": Mod19,
  "discourse/components/ai-agent-tool-options": Mod20,
  "discourse/components/ai-artifact": Mod21,
  "discourse/components/ai-blinking-animation": Mod22,
  "discourse/components/ai-bot-chats-tab": Mod23,
  "discourse/components/ai-bot-conversations": Mod24,
  "discourse/components/ai-bot-docked-composer": Mod25,
  "discourse/components/ai-bot-header-icon": Mod26,
  "discourse/components/ai-bot-sidebar-empty-state": Mod27,
  "discourse/components/ai-bot-sidebar-new-conversation": Mod28,
  "discourse/components/ai-composer-helper-menu": Mod29,
  "discourse/components/ai-conversation-sidebar-context-menu": Mod30,
  "discourse/components/ai-credit-bar": Mod31,
  "discourse/components/ai-feature-card": Mod32,
  "discourse/components/ai-features-list": Mod33,
  "discourse/components/ai-full-page-search": Mod34,
  "discourse/components/ai-gist-toggle": Mod35,
  "discourse/components/ai-helper-custom-prompt": Mod36,
  "discourse/components/ai-helper-loading": Mod37,
  "discourse/components/ai-helper-options-list": Mod38,
  "discourse/components/ai-indicator-wave": Mod39,
  "discourse/components/ai-llm-attachment-types": Mod40,
  "discourse/components/ai-llm-selector": Mod41,
  "discourse/components/ai-mcp-server-editor-form": Mod42,
  "discourse/components/ai-mcp-server-editor": Mod43,
  "discourse/components/ai-post-helper-menu": Mod44,
  "discourse/components/ai-quota-duration-selector": Mod45,
  "discourse/components/ai-regen-summaries-buttons": Mod46,
  "discourse/components/ai-search-discoveries-tooltip": Mod47,
  "discourse/components/ai-search-discoveries": Mod48,
  "discourse/components/ai-secret-editor-form": Mod49,
  "discourse/components/ai-secret-selector": Mod50,
  "discourse/components/ai-sentiment-horizontal-bar": Mod51,
  "discourse/components/ai-split-topic-suggester": Mod52,
  "discourse/components/ai-summary-skeleton": Mod53,
  "discourse/components/ai-tool-editor-form": Mod54,
  "discourse/components/ai-tool-editor": Mod55,
  "discourse/components/ai-tool-selector": Mod56,
  "discourse/components/ai-topic-gist": Mod57,
  "discourse/components/bulk-actions/ai-regen-summaries": Mod58,
  "discourse/components/modal/ai-agent-mcp-tool-selector-modal": Mod59,
  "discourse/components/modal/ai-agent-response-format-editor": Mod60,
  "discourse/components/modal/ai-llm-quota-modal": Mod61,
  "discourse/components/modal/ai-mcp-server-tools-modal": Mod62,
  "discourse/components/modal/ai-regen-summaries-modal": Mod63,
  "discourse/components/modal/ai-secret-create-modal": Mod64,
  "discourse/components/modal/ai-summary-modal": Mod65,
  "discourse/components/modal/ai-tool-test-modal": Mod66,
  "discourse/components/modal/chat-modal-channel-summary": Mod67,
  "discourse/components/modal/debug-ai-modal": Mod68,
  "discourse/components/modal/diff-modal": Mod69,
  "discourse/components/modal/share-full-topic-modal": Mod70,
  "discourse/components/modal/share-modal": Mod71,
  "discourse/components/modal/spam-test-modal": Mod72,
  "discourse/components/modal/thumbnail-suggestions": Mod73,
  "discourse/components/model-accuracies": Mod74,
  "discourse/components/post-menu/ai-cancel-streaming-button": Mod75,
  "discourse/components/post-menu/ai-debug-button": Mod76,
  "discourse/components/post-menu/ai-retry-streaming-button": Mod77,
  "discourse/components/post-menu/ai-share-button": Mod78,
  "discourse/components/post/ai-agent-flair": Mod79,
  "discourse/components/post/meta-data/ai-cancel-streaming": Mod80,
  "discourse/components/rag-options-fk": Mod81,
  "discourse/components/rag-upload-progress": Mod82,
  "discourse/components/rag-uploader": Mod83,
  "discourse/components/reviewable/ai-chat-message": Mod84,
  "discourse/components/reviewable/ai-post": Mod85,
  "discourse/components/reviewable/ai-tool-action": Mod86,
  "discourse/components/suggestion-menus/ai-category-suggester": Mod87,
  "discourse/components/suggestion-menus/ai-tag-suggester": Mod88,
  "discourse/components/suggestion-menus/ai-title-suggester": Mod89,
  "discourse/components/thumbnail-suggestion-item": Mod90,
  "discourse/connectors/admin-customize-theme-translation-selector/ai-theme-translate": Mod91,
  "discourse/connectors/admin-dashboard-highlights-before-kpis/ai-admin-dashboard-highlight": Mod92,
  "discourse/connectors/admin-dashboard-tabs-after/admin-sentiment-dashbboard": Mod93,
  "discourse/connectors/after-composer-title-input/ai-title-suggestion": Mod94,
  "discourse/connectors/after-d-editor/composer-open": Mod95,
  "discourse/connectors/after-filter-navigation-menu/filter-gist-toggle": Mod96,
  "discourse/connectors/after-search-result-entry/search-result-decoration": Mod97,
  "discourse/connectors/before-create-topic-button/topic-list-gist-toggle": Mod98,
  "discourse/connectors/composer-fields/agent-llm-selector": Mod99,
  "discourse/connectors/edit-topic-category__after/ai-category-suggestion": Mod100,
  "discourse/connectors/edit-topic-tags__after/ai-tag-suggestion": Mod101,
  "discourse/connectors/edit-topic-title__after/ai-title-suggestion": Mod102,
  "discourse/connectors/editor-preview/ai-image-caption-container": Mod103,
  "discourse/connectors/fast-edit-footer-after/ai-edit-suggestion-button": Mod104,
  "discourse/connectors/full-page-search-advanced-header/ai-full-page-search": Mod105,
  "discourse/connectors/full-page-search-before-results/ai-search-results-notice": Mod106,
  "discourse/connectors/full-page-search-below-search-header/ai-full-page-discobot-discoveries": Mod107,
  "discourse/connectors/post-menu-translations-dropdown/ai-post-menu-translation-extras": Mod108,
  "discourse/connectors/post-text-buttons/ai-post-helper-trigger": Mod109,
  "discourse/connectors/search-menu-before-advanced-search/ai-quick-search-loader": Mod110,
  "discourse/connectors/search-menu-results-bottom/ai-quick-search": Mod111,
  "discourse/connectors/search-menu-results-top/ai-discobot-discoveries": Mod112,
  "discourse/connectors/search-menu-results-top/ai-quick-search-info": Mod113,
  "discourse/connectors/search-menu-results-type-top/ai-quick-search-notice": Mod114,
  "discourse/connectors/split-new-topic-category-after/ai-category-suggestion": Mod115,
  "discourse/connectors/split-new-topic-tag-after/ai-tag-suggestion": Mod116,
  "discourse/connectors/split-new-topic-title-after/ai-title-suggestion": Mod117,
  "discourse/connectors/topic-map-expanded-after/ai-summary-trigger": Mod118,
  "discourse/connectors/topic-map-participants-after/ai-conversation-invite": Mod119,
  "discourse/connectors/user-messages-controls-bottom/pm-list-gist-toggle": Mod120,
  "discourse/connectors/user-preferences-interface/ai-search-discoveries": Mod121,
  "discourse/controllers/discourse-ai-bot-conversations": Mod122,
  "discourse/discourse-ai-bot-dashboard-route-map": Mod123,
  "discourse/discourse-ai-shared-conversation-show-route-map": Mod124,
  "discourse/initializers/add-ai-bot-to-community-section": Mod125,
  "discourse/initializers/admin-plugin-configuration-nav": Mod126,
  "discourse/initializers/ai-artifacts": Mod127,
  "discourse/initializers/ai-bot-pm": Mod128,
  "discourse/initializers/ai-bot-replies": Mod129,
  "discourse/initializers/ai-category-chooser-inline-suggester": Mod130,
  "discourse/initializers/ai-chat-summarization": Mod131,
  "discourse/initializers/ai-conversations-sidebar": Mod132,
  "discourse/initializers/ai-gist-connector": Mod133,
  "discourse/initializers/ai-gist-topic-list-class": Mod134,
  "discourse/initializers/ai-helper": Mod135,
  "discourse/initializers/ai-image-caption": Mod136,
  "discourse/initializers/ai-reviewable-status": Mod137,
  "discourse/initializers/ai-search-discoveries": Mod138,
  "discourse/initializers/ai-semantic-search": Mod139,
  "discourse/initializers/ai-sentiment-admin-nav": Mod140,
  "discourse/initializers/ai-tag-chooser-inline-suggester": Mod141,
  "discourse/initializers/ai-translation-topic-admin": Mod142,
  "discourse/initializers/related-topics": Mod143,
  "discourse/initializers/translation": Mod144,
  "discourse/lib/ai-bot-helper": Mod145,
  "discourse/lib/ai-errors": Mod146,
  "discourse/lib/ai-feature-setting-groups": Mod147,
  "discourse/lib/ai-helper-suggestions": Mod148,
  "discourse/lib/ai-streamer/progress-handlers": Mod149,
  "discourse/lib/ai-streamer/updaters/post-updater": Mod150,
  "discourse/lib/ai-streamer/updaters/stream-updater": Mod151,
  "discourse/lib/ai-topic-summary": Mod152,
  "discourse/lib/ai-usage-time-series": Mod153,
  "discourse/lib/copy-conversation": Mod154,
  "discourse/lib/diff-streamer": Mod155,
  "discourse/lib/llm-provider-param-helpers": Mod156,
  "discourse/lib/search-discoveries-context": Mod157,
  "discourse/lib/show-ai-helper": Mod158,
  "discourse/lib/smooth-streamer": Mod159,
  "discourse/lib/utilities": Mod160,
  "discourse/pre-initializers/ai-spam-transformers": Mod161,
  "discourse/routes/discourse-ai-bot-conversations": Mod162,
  "discourse/routes/discourse-ai-shared-conversation-show": Mod163,
  "discourse/services/ai-bot-conversations-hidden-submit": Mod164,
  "discourse/services/ai-bot-docked-submit": Mod165,
  "discourse/services/ai-bot-streaming-state": Mod166,
  "discourse/services/ai-conversations-sidebar-manager": Mod167,
  "discourse/services/ai-credits": Mod168,
  "discourse/services/discobot-discoveries": Mod169,
  "discourse/services/gists": Mod170,
  "discourse/services/image-caption-popup": Mod171,
  "discourse/services/quick-search": Mod172,
  "discourse/templates/discourse-ai-bot-conversations": Mod173,
  "lib/discourse-markdown/ai-tags": Mod174,
};
export default compatModules;
